export default function Tiktok({ ...props }) {
  return (
    <svg
      viewBox="0 0 398.67 398.67"
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="TikTok logo"
      {...props}
    >
      <g>
        <g>
          <circle
            cx="199.34"
            cy="199.34"
            r="199.34"
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#ffffff"
                : "#000000"
            }
          />
          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#25f4ee"
            }
            d="M171.6,165.74v-10.88c-3.73-.51-7.52-.83-11.39-.83-46.6,0-84.51,37.91-84.51,84.51,0,28.59,14.29,53.89,36.08,69.19-14.07-15.1-22.7-35.33-22.7-57.54,0-45.93,36.84-83.39,82.52-84.46Z"
          />
          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#25f4ee"
            }
            d="M173.59,288.8c20.79,0,37.75-16.54,38.52-37.14l.07-184.01h33.62c-.7-3.78-1.08-7.67-1.08-11.65h-45.92l-.07,184.01c-.77,20.61-17.73,37.14-38.52,37.14-6.46,0-12.55-1.62-17.9-4.43,7.02,9.72,18.41,16.09,31.29,16.09Z"
          />
          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#25f4ee"
            }
            d="M308.6,130.1v-10.23c-12.82,0-24.77-3.81-34.79-10.34,8.92,10.24,21.04,17.63,34.79,20.57Z"
          />

          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#fe2c55"
            }
            d="M273.81,109.52c-9.77-11.22-15.71-25.87-15.71-41.88h-12.3c3.24,17.49,13.62,32.5,28.01,41.88Z"
          />
          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#fe2c55"
            }
            d="M160.21,199.95c-21.28,0-38.6,17.31-38.6,38.6,0,14.82,8.41,27.7,20.69,34.16-4.58-6.34-7.31-14.11-7.31-22.51,0-21.28,17.32-38.6,38.6-38.6,3.97,0,7.78,.66,11.39,1.78v-46.87c-3.73-.51-7.52-.83-11.39-.83-.67,0-1.33,.04-2,.05v36c-3.6-1.13-7.42-1.78-11.39-1.78Z"
          />
          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#fe2c55"
            }
            d="M308.6,130.1v35.69c-23.81,0-45.87-7.62-63.88-20.54v93.31c0,46.6-37.91,84.51-84.51,84.51-18.01,0-34.71-5.68-48.43-15.32,15.44,16.57,37.43,26.97,61.82,26.97,46.6,0,84.51-37.91,84.51-84.51v-93.31c18.01,12.93,40.07,20.54,63.88,20.54v-45.92c-4.59,0-9.07-.5-13.38-1.42Z"
          />

          <path
            fill={
              props.color === "white" || props.color === "mobile-nav"
                ? "#01337d"
                : "#ffffff"
            }
            d="M244.72,238.55v-93.31c18.01,12.93,40.07,20.54,63.88,20.54v-35.69c-13.75-2.94-25.87-10.33-34.79-20.57-14.39-9.38-24.77-24.39-28.01-41.88h-33.62l-.07,184.01c-.77,20.61-17.73,37.14-38.52,37.14-12.88,0-24.27-6.36-31.29-16.09-12.29-6.47-20.69-19.34-20.69-34.16,0-21.28,17.32-38.6,38.6-38.6,3.97,0,7.78,.66,11.39,1.78v-36c-45.68,1.07-82.52,38.53-82.52,84.46,0,22.22,8.63,42.44,22.7,57.54,13.73,9.64,30.42,15.32,48.43,15.32,46.6,0,84.51-37.91,84.51-84.51Z"
          />
        </g>
      </g>
    </svg>
  );
}
